import React, { Component } from "react";
import SimplifiedLayout from "../SimplifiedLayout";
import { Grid, Col, Row } from "react-bootstrap";
import { browserHistory } from "react-router";
import Helmet from "react-helmet";

import axios from "axios";

class ActivateAccountPage extends Component {
    constructor() {
        super();
        this.state = { message: "Checking..." };
    }

    componentDidMount() {
        const key = this.props.location.query["key"];
        if (key) {
            this.sendActivationRequest(key);
        } else {
            this.setState({
                message: "Missing key, use the link from the activation email"
            });
        }
    }

    sendActivationRequest(key) {
        let that = this;
        axios
            .get("/api/activate?key=" + key)
            .then(function(response) {
                browserHistory.push("/signup/activated");
            })
            .catch(function(error) {
                that.setState({ message: "Account could not be activated" });
            });
    }

    render() {
        return (
            <div>
            	<Helmet title="Activate Account"/>
                <SimplifiedLayout>
                    <Grid className="text-center">
                        <Row>
                            <Col sm={12}>
                                <h1>
                                    <i
                                        className="fa fa-bullseye fa-3x"
                                        aria-hidden="true"
                                    />
                                </h1>
                                <h2>Activating your account</h2>
                                <h4>
                                    {this.state.message}
                                </h4>
                            </Col>
                        </Row>

                    </Grid>
                </SimplifiedLayout>
            </div>
        );
    }
}

export default ActivateAccountPage;



// WEBPACK FOOTER //
// ./src/signup/ActivateAccountPage.js